import { createPublicClient, http } from 'viem';
import { ChainId, PUBLIC_RPCS } from '../../../config/networks';
import { SupportedNetworks } from '../../../config/networkAddresses';
import { SOLANA_RPC_URL } from '../../../config/environment';
import { isNetworkSupported } from './isNetworkSupported';
import { Connection } from '@solana/web3.js';
import { CURRENT_VERSION } from '../../../config/environment';
/**
 * Returns an RPC client for the specified chain ID.
 * @param {IGetRpcClient} options - The options for getting the RPC client.
 * @param {number} options.chainId - The chain ID for which to get the RPC client.
 * @returns {Client} The RPC client for the specified chain ID.
 * @throws {Error} If the chain ID is not supported.
 */
export function getEVMRpcClient(_a) {
    var chainId = _a.chainId;
    var isSupportedNetwork = isNetworkSupported({ chainId: chainId });
    if (chainId == ChainId.SOLANA) {
        throw new Error('Solana is non-EVM');
    }
    var networkConfig = SupportedNetworks(CURRENT_VERSION)[chainId];
    // @ts-ignore
    return createPublicClient({
        chain: networkConfig.chain,
        transport: http(PUBLIC_RPCS[chainId]),
    });
}
export function getSolanaClient() {
    return new Connection(SOLANA_RPC_URL);
}
export function getRpcClient(_a) {
    var chainId = _a.chainId;
    if (chainId === ChainId.SOLANA || chainId == 7565164) {
        return getSolanaClient();
    }
    return getEVMRpcClient({ chainId: chainId });
}
